<template>
  <div class="contact-float-wrapper">

    <!-- 悬浮按钮 -->
    <div class="contact-btn" @click.stop="toggleContact">
      联系我们
    </div>

    <!-- 联系面板 -->
    <div
      v-show="isOpen"
      id="contactPanel"
      class="contact-panel"
      @click.stop
    >
    

      <!-- 数据社区 -->
      <div class="contact-item contact-item--community">
        <div class="icon icon2">📋</div>
        <div class="community-info">
          <div class="title">数据社区</div>
          <div class="desc">数据、AI专业社区</div>
          <div class="desc">或添加vx：Shujujuece</div>
          <div class="sub">定期线上/线下专业沙龙活动</div>
        </div>

        <div class="community-qr-wrap">
          <img class="community-qr" :src="qrShequ" alt="数据社区二维码" />
          <span class="community-qr-hint">扫码入群</span>
        </div>


      </div>

      <!-- 售前咨询 -->
      <div class="contact-item contact-item--qr">
        <div class="contact-item-top">
          <div class="icon icon3">💬</div>
          <div style="flex:1">
            <div class="title">售前咨询</div>
            <div class="desc">采购需求 / 获取报价 / 预约演示</div>
          </div>
        </div>
        <div class="qr-row">
          <div class="qr-item">
            <img class="qr" :src="qrGu" alt="顾问顾老师二维码" />
       <!--   
            <span class="qr-label">顾问 顾老师</span>
       -->
          </div>
          <div class="qr-item">
            <img class="qr" :src="qrSang" alt="顾问桑老师二维码" />
        <!--   
            <span class="qr-label">顾问 桑老师</span>
        -->
          </div>
        </div>
      </div>


      <!-- 热线电话 -->
      <div class="contact-item">
        <div class="icon icon4">☎</div>
        <div>
          <div class="title">热线电话</div>
          <div class="desc">咨询/故障救援邮箱：pmo@gushandata.cn</div>
          <div class="sub">总裁办24H投诉：18510176330</div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactFloat',
  data() {
    return {
      isOpen: false,
      qrGu: require('@/assets/img/qr_gu.jpg'),
      qrSang: require('@/assets/img/qr_sang.jpg'),
      qrShequ: require('@/assets/img/gzh_shujushequ.jpg')
    }
  },
  mounted() {
    document.addEventListener('click', this.handleOutsideClick)
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleOutsideClick)
  },
  methods: {
    toggleContact() {
      this.isOpen = !this.isOpen
    },
    handleOutsideClick() {
      if (this.isOpen) {
        this.isOpen = false
      }
    }
  }
}
</script>

<style scoped>
/* 右侧悬浮按钮 */
.contact-btn {
  position: fixed;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  background: linear-gradient(180deg, #2f7cf6, #1a5fe0);
  color: #fff;
  padding: 14px 10px;
  border-radius: 8px 0 0 8px;
  cursor: pointer;
  writing-mode: vertical-rl;
  text-align: center;
  font-size: 14px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  transition: all 0.2s;
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
  user-select: none;
  z-index: 9999;
}

.contact-btn:hover {
  transform: translateY(-50%) scale(1.05);
}

/* 弹窗 */
.contact-panel {
  position: fixed;
  right: 60px;
  top: 50%;
  transform: translateY(-50%);
  width: 360px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);
  border: 1px solid #eaeef5;
  padding: 16px;
  z-index: 9998;
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
}

/* 卡片 */
.contact-item {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 16px;
  border-radius: 8px;
  transition: all 0.2s;
  border: 1px solid transparent;
  margin-bottom: 12px;
}

.contact-item:last-child {
  margin-bottom: 0;
}

.contact-item:hover {
  background: #f5f8ff;
  border-color: #e6ecff;
}

/* 图标 */
.icon {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 18px;
  flex-shrink: 0;
}

.icon1 { background: linear-gradient(135deg, #4f8dfc, #2f7cf6); }
.icon2 { background: linear-gradient(135deg, #38d2c2, #2fb7a8); }
.icon3 { background: linear-gradient(135deg, #9b6cff, #7b4dff); }
.icon4 { background: linear-gradient(135deg, #6aa8ff, #3f86ff); }

/* 文本 */
.title {
  font-weight: 600;
  font-size: 15px;
  color: #333;
}

.desc {
  font-size: 13px;
  color: #666;
  margin-top: 4px;
}

.sub {
  font-size: 12px;
  color: #8a94a6;
  margin-top: 6px;
}

/* 推荐标签 */
.tag {
  position: absolute;
  right: 10px;
  top: 10px;
  background: #2f7cf6;
  color: #fff;
  font-size: 11px;
  padding: 2px 6px;
  border-radius: 4px;
}

/* 售前咨询：纵向布局 */
.contact-item--qr {
  flex-direction: column;
  gap: 10px;
}

/* 数据社区：左图标+文字，右二维码 */
.contact-item--community {
  align-items: center;
}
.community-info {
  flex: 1;
  min-width: 0;
}
.community-qr-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}
.community-qr {
  display: block;
  width: 64px;
  height: 64px;
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid #e0e6f0;
}
.community-qr-hint {
  font-size: 10px;
  color: #8a94a6;
}

.contact-item-top {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
}

/* 二维码行 */
.qr-row {
  display: flex;
  gap: 12px;
  justify-content: center;
  width: 100%;
  padding-top: 10px;
  border-top: 1px dashed #eaeef5;
}

.qr-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}

/* 二维码图片 */
.qr {
  display: block;
  width: 108px;
  height: 108px;
  object-fit: contain;
  flex-shrink: 0;
  border-radius: 0;
  background: #fff;
}

.qr-label {
  font-size: 12px;
  color: #8a94a6;
}
</style>
